import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-report-contact-dialog',
  templateUrl: './report-contact-dialog.component.html',
  styleUrls: ['./report-contact-dialog.component.scss']
})
export class ReportContactDialogComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<ReportContactDialogComponent>) { }

  selectedName
  selectedEmailAddress

  ngOnInit() {
  }
  DialogClose(){
    this.dialogRef.close();
  }

  
  
}
